// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"EditEdutainmentModal--next-sr-only--3zyMSfo","modalBody":"EditEdutainmentModal--modalBody--1hiygLS","actionButtons":"EditEdutainmentModal--actionButtons--2r7_zbU"};